<template>
  <div class="indexPage1">
    <!-- 将数据分为两份，两边展示 -->
    <div class="index-left">
      <div class="book-show fast-2" v-if="bookList.length>1">
        <div class="book-image">
          <el-image :src="bookList[1].pic == '/' ? require('../../assets/image/index/book.png') : bookList[1].pic" fit="cover"></el-image>
          <div :class="bookList[1].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[1].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[1].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[1].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[1].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-4" v-if="bookList.length>3">
        <div class="book-image">
          <el-image :src="bookList[3].pic == '/' ? require('../../assets/image/index/book.png') : bookList[3].pic" fit="cover"></el-image>
          <div :class="bookList[3].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[3].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[3].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[3].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[3].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-6" v-if="bookList.length>5">
        <div class="book-image">
          <el-image :src="bookList[5].pic == '/' ? require('../../assets/image/index/book.png') : bookList[5].pic" fit="cover"></el-image>
          <div :class="bookList[5].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[5].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[5].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[5].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[5].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-8" v-if="bookList.length>7">
        <div class="book-image">
          <el-image :src="bookList[7].pic == '/' ? require('../../assets/image/index/book.png') : bookList[7].pic" fit="cover"></el-image>
          <div :class="bookList[7].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[7].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[7].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[7].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[7].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-10" v-if="bookList.length>9">
        <div class="book-image">
          <el-image :src="bookList[9].pic == '/' ? require('../../assets/image/index/book.png') : bookList[9].pic" fit="cover"></el-image>
          <div :class="bookList[9].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[9].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[9].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[9].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[9].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>

      </div>
    </div>
    <div class="index-right">
      <div class="book-show fast-1" v-if="bookList.length>0">
        <div class="book-image">
          <el-image :src="bookList[0].pic == '/' ? require('../../assets/image/index/book.png') : bookList[0].pic" fit="cover"></el-image>
          <div :class="bookList[0].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[0].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[0].title}}》</div>
           <div class="fast-box">
            <div class="fast-box-title">《{{bookList[0].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[0].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>

      </div>
      <div class="book-show fast-3" v-if="bookList.length>2">
        <div class="book-image">
          <el-image :src="bookList[2].pic == '/' ? require('../../assets/image/index/book.png') : bookList[2].pic" fit="cover"></el-image>
          <div :class="bookList[2].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[2].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[2].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[2].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[2].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>

      </div>
      <div class="book-show fast-5" v-if="bookList.length>4">
        <div class="book-image">
          <el-image :src="bookList[4].pic == '/' ? require('../../assets/image/index/book.png') : bookList[4].pic" fit="cover"></el-image>
          <div :class="bookList[4].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[4].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[4].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[4].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[4].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-7" v-if="bookList.length>6">
        <div class="book-image">
          <el-image :src="bookList[6].pic == '/' ? require('../../assets/image/index/book.png') : bookList[6].pic" fit="cover"></el-image>
          <div :class="bookList[6].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[6].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[6].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[6].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[6].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
      <div class="book-show fast-9" v-if="bookList.length>8">
        <div class="book-image">
          <el-image :src="bookList[8].pic == '/' ? require('../../assets/image/index/book.png') : bookList[8].pic" fit="cover"></el-image>
          <div :class="bookList[8].pic == '/' ? '' : 'show'" class="image-tile">
            <div class="image-boder">
              {{bookList[8].title}}
            </div>
          </div>
          <div class="fast-1-title">《{{bookList[8].title}}》</div>
          <div class="fast-box">
            <div class="fast-box-title">《{{bookList[8].title}}》</div>
            <div @click="$router.push({path:'/resource/detail',query:{bookId:bookList[8].bookId}})" class="fast-box-xiangq">查看书籍>></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'indexPage',
    props: {
      bookList: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {};
    },

    mounted() {

    },

    methods: {},

  };
</script>

<style lang="less" scoped>
  .indexPage1 {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
    margin-top: 30px;
    .index-right, .index-left {
      width: 50vw;
      position: relative;

      .book-show {
        position: absolute;

        .book-image {
          display: flex;
          position: relative;
          cursor: pointer;
          background-color: rgba(0, 0, 0, 0.4);
          &::before {
              content: '';
              position: absolute;
              bottom: 0;
              left: 30rem;
              transform: skewX(-55deg);
              width: 45px;
              height: 36px;
              background-image: linear-gradient(to top, rgba(174, 174, 174, .9), rgba(255, 255, 255, .3));
          }
          .image-tile {
            position: absolute;
            left: 0.313rem;
            top: 0.313rem;
            writing-mode: vertical-rl;
            background-color: #f7eed9;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 1.667rem;
            height: 75%;

            &.show {
              display: none;
            }

            .image-boder {
              height: 100%;
              width: 1.354rem;
              margin: 0.1rem 0;
              border: solid 0.104rem #1d293b;
              font-size: 0.938rem;
              color: #333333;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
              word-break: break-all;
            }
          }
          .fast-1-title {
            font-size: 0.938rem;
            color: #333333;
            white-space: nowrap;
            max-width: 8.396rem;
            overflow: hidden;
            text-overflow: ellipsis; //多出部分用...代替
            position: absolute;
            bottom: -30px;
            left: 50%;
            transform: translateX(-50%);
          }
          .fast-box {
            z-index: 999;
            display: none;
            position: absolute;
            bottom: -111.251px;
            min-width: 50px;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 0.417rem;
            padding: 0.633em 0.573rem;
            background-color: rgba(0, 0, 0, 0.4);
            border-radius: 0.417rem;
            .fast-box-title {
              width: auto;
              white-space: nowrap;
              font-size: 1.042rem;
              color: #ffffff;
              border-bottom: 1px solid #ffffff;
              padding-bottom: 0.781rem;
              margin-bottom: 0.677rem;
            }

            .fast-box-xiangq {
              font-size: 1.042rem;
              color: #ffffff;
              cursor: pointer;
              white-space: pre;
            }
          }
        }

        &:hover {
          .book-image {
            .fast-1-title {
              display: none;
            }
            .fast-box {
              display: block;
            }
          }
        }

        &.fast-1 {
          left: 2.604rem;
          top: 15.104rem;
          .book-image{
            &::before{
              left:  6.396rem;
            }
          }
          .el-image {
            width: 7.396rem;
            height: 10.313rem;
          }
        }

        &.fast-2 {
          right: 18.125rem;
          top: 15rem;
          .book-image{
            &::before{
              left: 5.563rem;
            }
          }
          .el-image {
            width: 6.563rem;
            height: 9.115rem;
          }
        }

        &.fast-3 {
          left: 18.906rem;
          top: 14.375rem;
          .book-image{
            &::before{
              left: 4.677rem;
            }
          }
          .el-image {
            width: 5.677rem;
            height: 7.917rem;
          }
        }

        &.fast-4 {
          right: 27.781rem;
          top: 10.469rem;
          .book-image{
            &::before{
              left: 4.573rem;
            }
          }
          .el-image {
            width: 5.573rem;
            height: 7.813rem;
          }
        }

        &.fast-5 {
          left: 31.25rem;
          top: 9.063rem;
          .book-image{
            &::before{
              left: 4.313rem;
            }
          }
          .el-image {
            width: 5.313rem;
            height: 7.396rem;
          }
        }

        &.fast-6 {
          right: 9.74rem;
          top: 10.156rem;
          .book-image{
            &::before{
              left: 3.583rem;
            }
          }
          .el-image {
            width: 4.583rem;
            height: 6.406rem;
          }
        }

        &.fast-7 {
          left: 8.906rem;
          top: 6.875rem;
          .book-image{
            &::before{
              left: 3.271rem;
            }
          }
          .el-image {
            width: 4.271rem;
            height: 5.99rem;
          }
        }

        &.fast-8 {
          right: 1.875rem;
          top: 4.427rem;
          .book-image{
            &::before{
              left: 2.854rem;
            }
          }
          .el-image {
            width: 3.854rem;
            height: 5.417rem;
          }
        }

        &.fast-9 {
          left: 19.167rem;
          top: 6.198rem;
          .book-image{
            &::before{
              left:2.646rem;
            }
          }
          .el-image {
            width: 3.646rem;
            height: 5.104rem;
          }
        }

        &.fast-10 {
          right: 16.552rem;
          top: 4.406rem;
          .book-image{
            &::before{
              left:  3.271rem;
            }
          }
          .el-image {
            width: 4.271rem;
            height: 5.99rem;
          }
        }
      }
    }
  }
</style>
